import { NamespacedStoreState } from '@Types/store.types';
import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

export const getSensorTroubleshooting = (state: NamespacedStoreState) =>
	state.entitlements.editSensorData.peek.troubleshooting;

export const useSensorTroubleshootState = () =>
	useSelector(
		createSelector(
			[getSensorTroubleshooting],
			sensorTblt => sensorTblt || {},
		),
	);
